/**
 * @generated SignedSource<<4e375007433a5453337d87932ded727c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WeekComponentList_components$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"WeekComponentListItem_component">;
  readonly " $fragmentType": "WeekComponentList_components";
}>;
export type WeekComponentList_components$key = ReadonlyArray<{
  readonly " $data"?: WeekComponentList_components$data;
  readonly " $fragmentSpreads": FragmentRefs<"WeekComponentList_components">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "WeekComponentList_components",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WeekComponentListItem_component"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Component",
  "abstractKey": null
};

(node as any).hash = "c7ec6fb56527ee0bc89f990fe55bf09f";

export default node;
